import { Palette } from "../../constants/palettes";
import { memo } from 'react';
import { MegaMenuNoJsStyles, NavigationContainer, TopMenuContainer } from "./mega-menu.styles";
import RightNavigation from "./components/right-navigation/right-navigation";
import MegaMenuProvider from "./mega-menu-provider";
import MenuBackground from "./components/menu-background/menu-background";
import Logo from "./components/logo";
import TopMenu from "./components/top-menu/top-menu";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var MegaMenu = function MegaMenu(_ref) {
  var fixed = _ref.fixed,
    palette = _ref.palette,
    menuItems = _ref.menuItems,
    userMenuItems = _ref.userMenuItems,
    isFetchingUser = _ref.isFetchingUser,
    user = _ref.user,
    ctas = _ref.ctas,
    highlightedMobileLink = _ref.highlightedMobileLink,
    transparentBackground = _ref.transparentBackground,
    mobileMenuTriggerOpenLabel = _ref.mobileMenuTriggerOpenLabel,
    mobileMenuTriggerCloseLabel = _ref.mobileMenuTriggerCloseLabel,
    logoTitle = _ref.logoTitle,
    logoHref = _ref.logoHref,
    onLogoClick = _ref.onLogoClick,
    onUserMenuClick = _ref.onUserMenuClick,
    onUserMenuItemClick = _ref.onUserMenuItemClick,
    onMenuItemClick = _ref.onMenuItemClick,
    onSubMenuItemClick = _ref.onSubMenuItemClick,
    isMinimalMenu = _ref.isMinimalMenu;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(MegaMenuNoJsStyles, {
      palette: palette,
      transparentBackground: transparentBackground
    }), /*#__PURE__*/_jsx(MegaMenuProvider, {
      palette: palette,
      transparentBackground: transparentBackground,
      hasUser: !!user,
      hasUserMenuItems: !!userMenuItems,
      isFetchingUser: isFetchingUser,
      onUserMenuClick: onUserMenuClick,
      onUserMenuItemClick: onUserMenuItemClick,
      onMenuItemClick: onMenuItemClick,
      onSubMenuItemClick: onSubMenuItemClick,
      children: /*#__PURE__*/_jsx(NavigationContainer, {
        "data-qa": "navigation",
        fixed: fixed,
        "data-testid": "mega-menu",
        palette: palette,
        children: /*#__PURE__*/_jsxs(TopMenuContainer, {
          children: [/*#__PURE__*/_jsx(MenuBackground, {
            fixed: fixed
          }), /*#__PURE__*/_jsx(Logo, {
            title: logoTitle,
            href: logoHref,
            onClick: onLogoClick
          }), !isMinimalMenu && !!menuItems && /*#__PURE__*/_jsx(TopMenu, {
            mobileMenuTriggerOpenLabel: mobileMenuTriggerOpenLabel,
            mobileMenuTriggerCloseLabel: mobileMenuTriggerCloseLabel,
            menuItems: menuItems
          }), /*#__PURE__*/_jsx(RightNavigation, {
            isMinimalMenu: isMinimalMenu,
            userMenuItems: userMenuItems,
            user: user,
            ctas: ctas,
            highlightedMobileLink: highlightedMobileLink
          })]
        })
      })
    })]
  });
};
MegaMenu.defaultProps = {
  fixed: true,
  palette: Palette.Positive
};
export default /*#__PURE__*/memo(MegaMenu);